import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { InvoiceReminderExportCommandHandler } from './export-invoice-reminder-command-handler.service';
import { InvoiceReminderCommand } from '../../command/invoice-reminder';
import { OpenInvoiceFromReminderCommandHandler } from './open-invoice-from-reminder-command-handler.service';
import { PreviewInvoiceReminderCommandHandler } from './preview-invoice-reminder-command-handler.service';

@Injectable()
export class InvoiceReminderCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    invoiceReminderExportHandler: InvoiceReminderExportCommandHandler,
    openInvoiceFromReminderCommandHandler: OpenInvoiceFromReminderCommandHandler,
    previewInvoiceReminderCommandHandler: PreviewInvoiceReminderCommandHandler
  ) {
    super();
    this.addHandler(InvoiceReminderCommand.export, invoiceReminderExportHandler);
    this.addHandler(InvoiceReminderCommand.openInvoice, openInvoiceFromReminderCommandHandler);
    this.addHandler(InvoiceReminderCommand.previewReminder, previewInvoiceReminderCommandHandler);
  }
}
